/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { keyframes } from "styled-components";

export const show = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1
  }
`;

export const flashing = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1
  }
  100% {
    opacity: 0.5
  }
`;
